const fetchExternalAPIKey = factoringId => async (
  dispatch,
  getState,
  { api }
) => api.factoring.tms.fetchExternalAPIKey(factoringId);

export default fetchExternalAPIKey;
